export * from './registry.base';